import React from 'react';

import FloatingBanner from 'components/atoms/Button/FloatingBanner';
import './index.scss';

const PcFloatingBanner = ({ value, checked, label, icon, onChange, id }) => {
  return (
    <div className="PcFloatingBanner">
      <span className="radioArea">
        <FloatingBanner value={value} checked={checked} label={label} icon={icon} onChange={onChange} id={id} />
      </span>
    </div>
  );
};

export default PcFloatingBanner;